// EnergySource ids differ per inventory and titles are user-editable, so neither
// identifies a carrier. These values must match what the backfill migration writes.
export const ENERGY_SOURCE_KEY = {
    BIOGAS: "BIOGAS",
    BIOMASS: "BIOMASSE",
    LIGNITE: "BRAUNKOHLE",
    NATURAL_GAS: "ERDGAS",
    DISTRICT_HEATING: "FERNWAERME",
    LPG_STATIONARY: "FLUESSIGGAS",
    ELECTRICITY_FOR_HEATING: "HEIZSTROM",
    HEATING_OIL: "HEIZOEL",
    LOCAL_HEATING: "NAHWAERME",
    SOLAR_THERMAL: "SOLARTHERMIE",
    OTHER_RENEWABLES: "SONSTIGE_ERNEUERBARE",
    OTHER_CONVENTIONAL: "SONSTIGE_KONVENTIONELLE",
    HARD_COAL: "STEINKOHLE",
    ELECTRICITY: "STROM",
    ENVIRONMENTAL_HEAT: "UMWELTWAERME",
    GASOLINE_FOSSIL: "BENZIN",
    GASOLINE_BIOGENIC: "BIOBENZIN",
    DIESEL_FOSSIL: "DIESEL",
    DIESEL_BIOGENIC: "DIESEL_BIOGEN",
    KEROSENE: "KEROSIN",
    BIOGAS_TRANSPORT: "BIO_CNG",
    LPG_TRANSPORT: "LPG",
    NATURAL_GAS_CNG_LNG: "ERDGAS_CNG_LNG",
};
